<span *ngIf="minutes">
  <span>{{ prefix }}</span>
  <fa-icon [icon]="faClock"></fa-icon>
  <span>&nbsp;</span>
  <span>{{ minutes | minutes : condensed }}</span>
</span>
